import { Card, CardContent } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { widgetCheckoutFixesTests } from "./testDefinitions";

export const WidgetCheckoutSection = ({ testResults }) => {
  return (
    <Card className="shadow-none mb-4">
      <CardContent className="pt-4">
        <TestSubsection 
          title="Widget Checkout Fixes"
          tests={widgetCheckoutFixesTests}
          results={testResults.widgetCheckoutFixes}
        />
      </CardContent>
    </Card>
  );
};
